import api from "../../api";
import {dateStr2Timestamp, dateStr2Times} from '../../util/TimeTransition'
import {promptData, successPromptData} from "../../util/MessageTools";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor';

export default {
  name: 'editor',
  data() {
    return {
      data: [],
      noticeDialog: false,
      editor: null,
      isUseOptions: [{
        value: 1,
        label: "是",
      }, {
        value: 0,
        label: '否'
      }],
      editorData: "",
      currentRow: {},
      noticeForm: {
        title: null,
        issueTime: '',//发布时间
        isUse: 1,//是否展示
        sortNum: 0//顺序
      },
      noticeDialogTitle: "",
      flag: '',//0为添加  1为编辑
      content: '',
      editorOption: {
        placeholder: '编辑文章内容'
      },
      tableLoading:false
    }
  },
  components: {
    quillEditor
  },
  mounted() {

  },
  methods: {

    onEditorChange({editor, html, text}) {
      this.content = html;
    },

    /**
     * 打开添加新闻的弹出框
     */
    addNoticeDialog() {
      this.flag = 0
      this.noticeDialogTitle = "添加新闻"
      this.noticeDialog = true
      this.noticeForm.title = ""
      this.noticeForm.sortNum = ""
      this.noticeForm.isUse = 1
      this.content = ""
    },

    /**
     * 编辑一条新闻
     * @param row
     */
    editNotice(row) {
      this.flag = 1
      this.noticeDialogTitle = "修改新闻"
      this.currentRow = row
      this.noticeDialog = true
      this.noticeForm.title = row.title
      this.noticeForm.sortNum = row.sortNum
      this.noticeForm.issueTime = new Date(row.issueTime)
      if (row.isUse === "是") {
        this.noticeForm.isUse = 1
      } else {
        this.noticeForm.isUse = 0
      }
      let vue = this
      api.notice.getById(row.id).then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          vue.content = result.content
        }
      })
    },

    /**
     * 删除一条新闻
     * @param index 下标
     * @param row  选中行数据
     */
    deleteNotice(index, row) {
      let vue = this
      api.notice.delById(row.id).then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          let result  =response.data.result
          vue.disposeResult(result)
          successPromptData("删除新闻成功!", vue)
          //vue.data.splice(index, 1)
        }
      })
    },

    /**
     * 预览新闻
     */
    viewNotice() {
      let params = {
        "title": this.noticeForm.title,
        "releaseDate": dateStr2Times(new Date()),
        "content": this.content
      };
      window["filter"] = params;
      let routeUrl = this.$router.resolve({
        path: '/preview',
      });
      window.open(routeUrl.href, '_blank');
    },

    /**
     * 保存新闻
     */
    saveNotice() {
      let vue = this
      if (this.noticeForm.title === "" || this.noticeForm.title == null) {
        promptData("请填写标题!", this)
        return
      }
      if (this.content === "" || this.content === null) {
        promptData("请填写内容!", this)
        return;
      }
      if (this.noticeForm.sortNum === "" || this.noticeForm.sortNum == null) {
        promptData("请填写顺序!", this)
        return
      }

      let obj = {}
      obj.issueTime = new Date()
      obj.title = this.noticeForm.title
      obj.sortNum = this.noticeForm.sortNum
      obj.content = this.content
      obj.isUse = this.noticeForm.isUse

      if (this.flag === 0) {
        api.notice.addNewsNotice(obj).then(function (response) {
          if (response == null) {
            return null
          }
          if (response.data.code === "0") {
            let result = response.data.result;
            vue.disposeResult(result)
           /* obj.issueTime = dateStr2Times(obj.issueTime)
            if (vue.noticeForm.isUse === 1) {
              obj.isUse = "是"
            } else {
              obj.isUse = "否"
            }
            obj.id = response.data.result
            vue.data.push(obj)*/
            vue.noticeDialog = false
            successPromptData("添加新闻成功!", vue)
          }
        })
      } else {
        obj.id = this.currentRow.id
        api.notice.update(obj).then(function (response) {
          if (response == null) {
            return null
          }
          if (response.data.code === "0") {
            /*for (let i = 0; i < vue.data.length; i++) {
              if (vue.data[i].id === vue.currentRow.id) {
                vue.data[i].title = vue.noticeForm.title
                vue.data[i].issueTime = dateStr2Times(new Date())
                if (vue.noticeForm.isUse === 1) {
                  vue.data[i].isUse = "是"
                } else {
                  vue.data[i].isUse = "否"
                }
                vue.data[i].content = vue.content
                break
              }
            }*/
            let result = response.data.result;
            vue.disposeResult(result)
            vue.noticeDialog = false
            successPromptData("修改新闻成功!", vue)
          }
        })
      }
    },

    /**
     * 处理结果
     * @param result
     */
    disposeResult(result) {
      for (let i = 0; i < result.length; i++) {
        result[i].issueTime = dateStr2Times(result[i].issueTime)
        if (result[i].isUse === 1) {
          result[i].isUse = "是"
        } else {
          result[i].isUse = "否"
        }
      }
      this.data = result
    }
  },

  created() {
    let vue = this
    vue.tableLoading = true
    api.notice.getAll().then(function (response) {
      vue.tableLoading = false
      if (response == null) {
        return null
      }
      if (response.data.code === "0") {
        let result = response.data.result
        vue.disposeResult(result)
      }
    }).catch(err=>{
      vue.tableLoading = false
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/Admin/NoticeManage.js